(function () {
  'use strict';

  function localizeJudgeMeLabels() {
    document.querySelectorAll('.jdgm-arrow[aria-label], .jdgm-stars[aria-label], .jdgm-prev-badge__stars[aria-label]').forEach(function (element) {
      var label = element.getAttribute('aria-label');
      if (!label) return;

      if (label === 'Previous slide') {
        element.setAttribute('aria-label', 'Vorige review');
        return;
      }
      if (label === 'Next slide') {
        element.setAttribute('aria-label', 'Volgende review');
        return;
      }

      var fullRating = label.match(/^(\d+(?:\.\d+)?) out of 5 stars$/i);
      if (fullRating) {
        element.setAttribute('aria-label', fullRating[1].replace('.', ',') + ' van 5 sterren');
        return;
      }

      var starRating = label.match(/^(\d+(?:\.\d+)?) stars$/i);
      if (starRating) {
        element.setAttribute('aria-label', starRating[1].replace('.', ',') + ' sterren');
      }
    });
  }

  function initJudgeMeLocalization() {
    localizeJudgeMeLabels();
    var observer = new MutationObserver(localizeJudgeMeLabels);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJudgeMeLocalization, { once: true });
  } else {
    initJudgeMeLocalization();
  }
})();
